import { required, TRequiredCodec } from "../../../shared/src/codecs/types/required";
import { PartyDataFormIO, TPartyDataFormIOCodec } from "../formIO/PartyDataFormIO";

export const PartyPagePartial: TRequiredCodec<{
    data: TPartyDataFormIOCodec;
}> = required({
    data: PartyDataFormIO,
});

export type TPartyPagePartialCodec = typeof PartyPagePartial;
